import Alert from 'react-bootstrap/Alert';
import { Icon } from './Icon';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

export function AlertComponent({ variant, message }: { variant?: string, message: string }) {
    return Boolean(message) ? (
        <Alert
            className="fw-bold border-3"
            variant={variant ?? 'danger'}
            role="alert"
            aria-live="polite"
        >
            <Icon icon={variant ? faCheckCircle : faExclamationCircle} aria-hidden="true" />
            {' '}{message}
        </Alert>
    ) : null
}
